$(() => {
  $('.calendly').off('click touchstart').on('click touchstart', function() {
    Calendly.initPopupWidget({ url: 'https://calendly.com/colorimpact/60min' });
    return false;
  });
});
